
import GenreMaker from '../anychart/genreMaker'; 

var AreaChart = class AreaChart extends GenreMaker {

    setData(state){
        super.setData(state);
        var subGenre = this.getSubGenre(state);
        var chart = anychart.area();
        for (var series in this.data) {

            if(this.ifIncluded("spline")){
                this.chart.splineArea(this.data[series]);
            }else if(this.ifIncluded("step")){
                this.chart.stepArea(this.data[series]);
            }else{
                this.chart.area(this.data[series]);
            }
        }
    }

    createChart(){
        var chart = anychart.area();
        // if(this.ifIncluded("3d") && !this.ifSeries()){
        //     var chart = anychart.area3d();
        // }
        
        return chart;
    }; 
};


    
GenreMaker.area = AreaChart;

export var AreaChart;



// WEBPACK FOOTER //
// ./src/anychart/areaChart.js